/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './RoomForm.css';

import {
  listLocationsAuth,
  upload,
} from '../../actions';


let fieldNames = [
  'name',
  'url',
  'description',
  'locationId',
  'minPeople',
  'maxPeople',
  'difficulty',
  'minutes',
  'privacy',
  'scary',
];

function fieldNameTrans(f) {
  if (f == 'locationId') {
    return 'locationUgcId';
  }
  return f + 'Ugc';
}

let ugcFieldNames = fieldNames.map(fieldNameTrans);


class ImageForm extends OzFormComponent {
  static fields = [
    'url',
  ]

  renderBody() {
    return (
      <div className="ImageForm">
        {this.renderFormGroup(null, 'image', 'url')}
      </div>
    );
  }
}


class RoomForm extends OzFormComponent {

  static fields = ugcFieldNames.concat(['images']);

  options = {
    images: {
      init: {
        url: null,
      }
    },
  };

  constructor(props) {
    super(props);
    for (let field of fieldNames) {
      let fieldUgc = fieldNameTrans(field);
      if (!this.state[fieldUgc] && props.values[field]) {
        this.state[fieldUgc] = props.values[field];
      }
    }
  }

  componentDidMount() {
    this.props.listLocationsAuth({ mine: 1, noGeo: 1 }, { targetKey: 'locationAuth' });
  }

  renderImages() {
    let images = this.state.images || [];
    let i = 0;
    let nodes = images.map(image => {
      let index = i;
      i++;
      return (
        <ImageForm
          key={image.id}
          index={image.id}
          errors={this.props.errors ? this.props.errors.images[index] : null}
          part={true}
          values={image}
          cancelRender={() => <Button bsSize="sm">Remove</Button>}
          onCancel={() => this.removeMany(image.id, 'images')}
          onChange={(values) => this.updateMany(image.id, values, 'images')}
          upload={this.props.upload}
        />
      );
    });

    return (
      <div className="images-wrapper">
        {nodes}
      </div>
    );
  }

  renderBody() {
    if (!this.props.locations) return null;

    console.log('room form locations', this.props.locations);
    let locationOptions = this.props.locations.items.map(l => [l.id, l.company + ', ' + l.address]);

    let privacyOptions = [
      ['always', 'Always private'],
      ['no', 'Not always private (includes extra fee for private booking)'],
    ];

    let scaryOptions = [
      ['no', 'Not a scary room'],
      ['little', 'A little scary'],
      ['scary', 'Yes! This is a scary room'],
    ];

    return (
      <div className="RoomForm">
        {this.renderFormGroup('Location', 'select', 'locationUgcId', locationOptions)}

        {this.renderFormGroup('Name', 'text', 'nameUgc', { helptext: 'This will show up in page titles and as the room name in listings. Please do not add your company name, which will already be there.' })}

        {this.renderFormGroup('Room URL', 'text', 'urlUgc', { helptext: 'This will be used for the offsite link from EscapeSpy to this room' })}

        {this.renderFormGroup('Description', 'textarea', 'descriptionUgc', { helptext: 'Freeform description of your room. You can put some intro text. Long descriptions may be truncated with a "Show More" button.' })}

        {this.renderFormGroupPair(
          ['Min players', 'selectNumber', 'minPeopleUgc', { min: 1, max: 25 }],
          ['Max players', 'selectNumber', 'maxPeopleUgc', { min: 1, max: 25 }])}

        {this.renderFormGroup('Difficulty', 'text', 'difficultyUgc', { helptext: 'Describe the difficulty of this room in any format that you use.' })}

        {this.renderFormGroup('Game length in minutes', 'selectNumber', 'minutesUgc', { min: 5, max: 300, incr: 5, suffix: 'minute', suffixPlural: 'minutes' })}

        {this.renderFormGroup('Are bookings always private?', 'radio', 'privacyUgc', privacyOptions)}

        {this.renderFormGroup('Is this a scary room?', 'select', 'scaryUgc', scaryOptions)}

        {this.renderImages()}
        <div className="add-image">
          <Button onClick={() => this.addMany('images')}>Add Image</Button>
        </div>

      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    locations: state.list.locationAuth,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listLocationsAuth,
    upload,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoomForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/RoomForm.js
 **/